import validator from 'validator';
import { trimDialCode } from '../../../../../auth/components/signup-form/validator';

export const validate = (
  name: string,
  value: string,
  hasPermissionToUpdateProfile: boolean,
  dialCode: string,
  showPhoneNumberInput: boolean,
) => {
  if (hasPermissionToUpdateProfile) {
    if (name === 'firstName') {
      if (!validator.isLength(value, { max: 25 })) {
        return 'First name should be at most 25 characters long';
      }
    }
    if (name === 'lastName') {
      if (!validator.isLength(value, { max: 25 })) {
        return 'Last name should be at most 25 characters long';
      }
    }
    if (name === 'phone') {
      if (!showPhoneNumberInput) {
        return '';
      }

      if (validator.isEmpty(trimDialCode(value, dialCode))) {
        return 'Phone number can’t be empty.';
      }

      if (
        !validator.isLength(trimDialCode(value, dialCode), { min: 4, max: 15 })
      ) {
        return 'Phone number must be 10 digits.';
      }
    }
  }

  return '';
};
